<template>
  <v-row>
    <v-col class="xs" cols="12" lg="10" offset-lg="1">
      <v-breadcrumbs divider=">" :items="breadcrumbs" class="pb-3 pl-1" />
      <v-card class="mb-1 ck-content">
        <v-card-title class="theme">
          <v-icon class="white--text">volume_up</v-icon>
          <span class="headline ml-2 white--text">Announcement</span>
          <v-spacer />
        </v-card-title>
        <v-divider />
        <v-row>
          <v-col cols="1" sm="1" md="1" class="hidden-sm-and-down xs">
            <v-avatar
              size="85"
              v-if="announcement.user_image_profile"
              class="mx-5 my-5"
            >
              <v-img :src="announcement.user_image_profile"></v-img>
            </v-avatar>

            <v-avatar height="100" width="100" v-else>
              <v-icon class="white--text grey lighten-1" x-large>
                perm_identity
              </v-icon>
            </v-avatar>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="8"
            class="offset-sm-2 offset-xs-1 offset-lg-0 offset-md-0 xs"
          >
            <h1 class="pl-5 my-3 darkertext ml-5">{{ announcement.title }}</h1>

            <div class="pl-5 mb-2 body-2 font-weight-bold ml-5">
              {{ announcement.user_name }}
            </div>

            <div
              class="pl-5 mb-5 body-2 ml-5"
              style="margin-top: -0.5rem"
              v-if="announcement.type"
            >
              {{ announcement.created_at_formatted }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="10" class="offset-md-1 offset-sm-2 xs">
            <div
              class="px-5 mb-5 darkertext ml-5"
              v-html="announcement.description"
            ></div>

            <v-divider class="mb-7" />
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Constants } from "@/views/constants";

export default {
  name: "ReadOnlyAnnouncement",
  data: () => ({
    announcement: {
      type: "",
      title: "",
      expires_at: "",
      description: "",
      visibility: "",
    },
    breadcrumbs: Breadcrumbs.Announcement.ReadOnly,
  }),
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    getAnnouncement() {
      this.$store
        .dispatch(Actions.Announcement.Get, this.$route.params.id)
        .then((r) => {
          if (r.status === 200) {
            this.announcement = {
              ...r.data,
              created_at: this.formatFromDate(r.data.created_at),
              expires_at: r.data.expires_at
                ? r.data.expires_at.substring(0, 10)
                : "",
            };
          }
        })
        .catch((e) => {
          console.error(Constants.Announcement.Messages.Error.Get, e);
          this.snackbar = true;
          this.snackbarMessage = Constants.Announcement.Messages.Error.Get;
        });
    },
  },
  created() {
    if (this.userInfo) {
      this.getAnnouncement();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.getAnnouncement());
    }
  },
};
</script>

<style>
.darkertext {
  color: #272929;
}
h1{
  margin-bottom: 0.5rem;
  font-family: Roboto Slab;
}
h2,h3{
  font-family: Roboto Slab;
}
@media (max-width: 768px) {
    h1 {
        font-size: 20px;
    }
    h2{
      font-size: 18px
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    h1 {
        font-size: 22px;
    }
    h2{
      font-size: 20px;
    }
}
</style>